// ============================================================================
// Builder Types
// ============================================================================

export type InterpolationMetadata<Params extends readonly string[]> = {
  _type: 'interpolation'
  template: string
  params: Params
}

export type PluralRules = {
  zero?: string
  one?: string
  two?: string
  few?: string
  many?: string
  other: string
}

export type PluralMetadata = {
  _type: 'plural'
  rules: PluralRules
}

// ============================================================================
// i18n Builders
// ============================================================================

export const i18n = <Params extends readonly string[]>(
  strings: TemplateStringsArray,
  ...keys: Params
): InterpolationMetadata<Params> => {
  // Build template with {{param}} placeholders
  let template = strings[0]
  for (let i = 0; i < keys.length; i++) {
    template += `{{${keys[i]}}}${strings[i + 1]}`
  }

  return {
    _type: 'interpolation',
    template,
    params: keys,
  }
}

i18n.count = (rules: PluralRules): PluralMetadata => {
  return {
    _type: 'plural',
    rules,
  }
}
